import { Component, OnInit, OnDestroy } from '@angular/core';
import { FormBuilder, FormArray, FormGroup, FormControl, Validators } from '@angular/forms';

import { AlertService } from '../../services/alert.service';
import { ChallengeService } from '../../services/challenge.service';
import { ProgressIndicatorService } from '../../services/progress-indicator.service';

@Component({
    selector: 'challenge',
    templateUrl: './challenge.component.html',
    styleUrls: ['./challenge.component.scss']
})
export class ChallengeComponent implements OnInit, OnDestroy {

    newChallengeVisible: boolean = true;

    newChallengeFormGroup!: FormGroup;

    newChallengeSelectedMini!: File | null;

    newChallengeSelectedFile!: File | null;

    challenges: any[] = [];

    constructor(
        private alertService: AlertService,
        private progressIndicatorService: ProgressIndicatorService,
        private challengeService: ChallengeService,
        private formBuilder: FormBuilder
    ) {
    }

    ngOnInit() {
        this.newChallengeFormGroup = this.formBuilder.group({
            newChallengeMiniInput: [null, Validators.required],
            newChallengeFileInput: [null, /*Validators.required*/],
            newChallengeNameInput: [null, Validators.required],
            newChallengeTypeSelect: [{ value: 'DISTANCE', disabled: false }, Validators.required],
            newChallengeStartInput: [null, Validators.required],
            newChallengeEndInput: [null, Validators.required],
            newChallengeTargetInput: [null, Validators.required],
            newChallengeOrderBySelect: [{ value: 'DURATION', disabled: false }, Validators.required],
            newChallengeLimitInput: [null, Validators.required],
            newChallengeDetailFormArray: this.formBuilder.array([])
        });
        this.refreshChallenges();
    }

    ngOnDestroy() {
    }

    getNewChallengeDetailFormArray(): any {
        return this.newChallengeFormGroup.get('newChallengeDetailFormArray') as FormArray;
    }

    refreshChallenges() {
        this.newChallengeFormGroup.reset();
        let newChallengeDetailFormArray: FormArray = this.newChallengeFormGroup.get('newChallengeDetailFormArray') as FormArray;
        while (newChallengeDetailFormArray.length > 0) {
            newChallengeDetailFormArray.removeAt(0);
        }
        newChallengeDetailFormArray.push(this.formBuilder.group({
            newChallengeDetailLocaleInput: [null, Validators.required],
            newChallengeDetailDetailnput: [null, Validators.required],
        }));
        this.newChallengeSelectedMini = null;
        this.newChallengeSelectedFile = null;
        this.getChallenges();
    }

    addChallengeDetail() {
        let newChallengeDetailFormArray: FormArray = this.newChallengeFormGroup.get('newChallengeDetailFormArray') as FormArray;
        newChallengeDetailFormArray.push(this.formBuilder.group({
            newChallengeDetailLocaleInput: [null, Validators.required],
            newChallengeDetailDetailnput: [null, Validators.required],
        }));
    }

    removeChallengeDetail(index: number) {
        let newChallengeDetailFormArray: FormArray = this.newChallengeFormGroup.get('newChallengeDetailFormArray') as FormArray;
        newChallengeDetailFormArray.removeAt(index);
    }

    getChallenges() {
        this.progressIndicatorService.progress = true;
        this.challengeService.getChallenges().subscribe({
            next: (value: any) => {
                console.log('ChallengeComponent.getChallenges.challengeService.getChallenges.value', value);
                this.progressIndicatorService.progress = false;
                this.challenges = value.challenges;
                this.challenges.sort((a, b) => b.id - a.id);
                this.challenges.forEach(challenge => challenge.details.sort((a: any, b: any) => a.locale.localeCompare(b.locale)));
            },
            error: (error: any) => {
                console.log('ChallengeComponent.getChallenges.challengeService.getChallenges.error', error);
                this.progressIndicatorService.progress = false;
                this.alertService.danger('Error');
            }
        });
    }

    newChallengeMiniInputChange(event: any) {
        let mini: File = event.target.files[0];
        this.newChallengeSelectedMini = mini;
    }

    newChallengeFileInputChange(event: any) {
        let file: File = event.target.files[0];
        this.newChallengeSelectedFile = file;
    }

    uploadNewChallenge() {

        let formGroup: FormGroup = this.newChallengeFormGroup;

        let mini: File | null = this.newChallengeSelectedMini;
        let file: File | null = mini;//this.newChallengeSelectedFile;
        if (mini == null) return;
        if (file == null) return;

        let name: string = formGroup.value.newChallengeNameInput;
        let start: string = formGroup.value.newChallengeStartInput;
        let end: string = formGroup.value.newChallengeEndInput;
        let target: number = formGroup.value.newChallengeTargetInput;
        let type: string = formGroup.value.newChallengeTypeSelect;
        let orderBy: string = formGroup.value.newChallengeOrderBySelect;
        let limit: number = formGroup.value.newChallengeLimitInput;
        let details: any[] = formGroup.value.newChallengeDetailFormArray.map((value: any) => ({ locale: value.newChallengeDetailLocaleInput, detail: value.newChallengeDetailDetailnput }));

        this.progressIndicatorService.progress = true;
        this.challengeService.uploadNewChallenge(mini, file, name, start, end, target, type, orderBy, limit, details).subscribe({
            next: (value: any) => {
                console.log('ChallengeComponent.uploadNewChallenge.challengeService.uploadNewChallenge.value', value);
                this.progressIndicatorService.progress = false;
                this.alertService.success('Success');
                this.refreshChallenges();
            },
            error: (error: any) => {
                console.log('ChallengeComponent.uploadNewChallenge.challengeService.uploadNewChallenge.error', error);
                this.progressIndicatorService.progress = false;
                this.alertService.danger('Error');
            }
        });
    }
}
